import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ContactTypeEnum } from '@commons/contact-modal/contact-modal.component';
import { BreakpointsService } from '@core/services/breakpoints/breakpoints.service';
import {
  CejV2ContactModalComponent,
  CejV2ContactModalModule,
} from '@domains/cej-v2/cej-v2-contact-modal/cej-v2-contact-modal.component';
import { environment } from '@environment';
import { trackConversion, trackEventWithAtInternet } from '@wizbii/tracking';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-cej-v2-contact',
  templateUrl: './cej-v2-contact.component.html',
  styleUrls: ['./cej-v2-contact.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CejV2ContactComponent {
  trackEvent = trackEventWithAtInternet;
  readonly ContactTypeEnum = ContactTypeEnum;

  get isMobile$(): Observable<boolean> {
    return this.breakpointsService.isMobile$;
  }

  openContactModal(): void {
    this.trackEvent({
      category: 'CEJ',
      action: 'Click Rester informé',
      type: 'action',
    });

    if (environment.platform === 'prod') {
      trackConversion({ allow_custom_scripts: true, send_to: 'DC-3048978/forma0/lpinfo+standard' });
    }

    this.isMobile$.pipe(take(1)).subscribe({
      next: (isMobile: boolean): void => {
        const options = {
          panelClass: isMobile ? 'wizbii-mobile-panel--white' : 'wizbii-panel--white',
          backdropClass: 'wzb-backdrop',
          maxWidth: isMobile ? '100vw' : '',
          autoFocus: false,
          data: {
            isMobile,
          },
          disableClose: isMobile,
          position: isMobile ? { bottom: '0' } : {},
        };

        this.dialog.open(CejV2ContactModalComponent, options);
      },
    });
  }
  constructor(private readonly breakpointsService: BreakpointsService, private readonly dialog: MatDialog) {}
}

@NgModule({
  imports: [CejV2ContactModalModule],
  declarations: [CejV2ContactComponent],
  exports: [CejV2ContactComponent],
})
export class CejV2ContactModule {}
